import React from 'react';

import { iconUri } from '@nerdwallet/nw-client-lib/cdn';

// CSS
require('./api-error-icon.less');

const ApiErrorIcon = () => (
  <div className="api-error-icon">
    <img
      src={iconUri('api_error_desktop')}
      alt=""
      className="api-error-icon-desktop"
    />
    <img
      src={iconUri('api_error_mobile')}
      alt=""
      className="api-error-icon-mobile"
    />
  </div>
);
ApiErrorIcon.displayName = 'ApiErrorIcon';

export default ApiErrorIcon;
